define('presentation/settings/accountProfile/validators/accountProfileValidator',['businessServices/converters/textConverter',
        'businessServices/country/countryRegions',
        'businessServices/specifications/validPostalCodeSpecification',
        'common/collections/enumerationValidator',
        'common/time/date',
        'common/specifications/validEmailAddressSpecification',
        'common/specifications/validUrlAddressSpecification',
        'constants/companySizeEnumerations',
        'constants/countryEnumerations',
        'constants/marketingIndustryEnumerations',
        'presentation/common/validation/commonValidator',
        'presentation/common/validation/validationRule',
], function() {
    return function() {
        const self = this;

        const CountryRegionsConstructor = require('businessServices/country/countryRegions');
        const _countryRegions = new CountryRegionsConstructor();

        const DateConstructor = require('common/time/date');

        const TextConverterConstructor = require('businessServices/converters/textConverter');
        const _textConverter = new TextConverterConstructor();

        const ValidEmailAddressSpecificationConstructor = require('common/specifications/validEmailAddressSpecification');
        const _validEmailAddressSpecification = new ValidEmailAddressSpecificationConstructor();

        const ValidPostalCodeConstructor = require('businessServices/specifications/validPostalCodeSpecification');
        const _validPostalCodeSpecification = new ValidPostalCodeConstructor();

        const ValidUrlAddressSpecification = require('common/specifications/validUrlAddressSpecification');
        const _validUrlAddressSpecification = new ValidUrlAddressSpecification();

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

        const _countryEnumerations = require('constants/countryEnumerations');
        const _enumerationValidator = require('common/collections/enumerationValidator');

        let _commonValidator = null;
        let _facade = null;
        let _viewModel = null;

        const COMPANY_SIZES = require('constants/companySizeEnumerations');
        const INDUSTRIES = require('constants/marketingIndustryEnumerations');

        self.registerViewModel = (viewModel, facade) => {
            _facade = facade;
            _viewModel = viewModel;
            _commonValidator = new CommonValidatorConstructor(viewModel);

            const validationRules = new ValidationRulesConstructor();
            validationRules.field("accountHolderFirstName")
                .addValidationI18n(_commonValidator.isStringWithValue, 'accountProfile:firstNameRequired');
            validationRules.field("accountHolderLastName")
                .addValidationI18n(_commonValidator.isStringWithValue, 'accountProfile:lastNameRequired');
            validationRules.field("addressLineOne")
                .addValidationI18n(_commonValidator.isStringWithValue, 'accountProfile:addressRequired');
            validationRules.field("city")
                .addValidationI18n(_commonValidator.isStringWithValue, 'accountProfile:cityRequired');
            validationRules.field("stateOrProvince")
                .addValidationI18n(_validateStateOrProvince, _stateOrProvinceRequiredI18nKey);
            validationRules.field("zipOrPostalCode")
                .addValidationI18n(_commonValidator.isStringWithValue, _zipOrPostalCodeRequiredI18nKey)
                .addValidationI18n(_validateZipOrPostalCodeInvalid, _zipOrPostalCodeInvalidI18nKey)
                .addValidationI18n(_validateZipOrPostalCodeExists, _zipOrPostalCodeInvalidI18nKey);
            validationRules.field("inBusinessSince")
                .addValidationI18n(_validateMonthYearValid, 'accountProfile:monthYearFoundedInvalid');
            validationRules.field("numberOfEmployees")
                .addValidationI18n(_validateCompanySize, 'accountProfile:companySizeRequired');
            validationRules.field("industry")
                .addValidationI18n(_validateIndustryRequired, 'accountProfile:industryRequired');
            validationRules.field("timeZone")
                .addValidationI18n(_commonValidator.isStringWithValue, 'accountProfile:timeZoneRequired');
            validationRules.field("websiteUrl")
                .addValidationI18n(_validateWebsiteUrl, 'accountProfile:websiteUrlInvalid');
            validationRules.array("billingCommunicationEmailAddresses")
                .arrayField("emailAddress")
                .addValidationI18n(_validEmailAddressSpecification.isSatisfiedBy, 'emailAddressInvalid')
                .addValidationI18n(_isEmailAddressUnique, 'accountProfile:emailAddressNotUnique');

            _commonValidator.useManualValidation();
            _commonValidator.setValidationRules(validationRules);
        };

        self.validate = () => {
            return _commonValidator.validate();
        };

        self.resetValidation = () => {
            _viewModel.accountHolderFirstName.resetValidation();
            _viewModel.accountHolderLastName.resetValidation();
            _viewModel.addressLineOne.resetValidation();
            _viewModel.city.resetValidation();
            _viewModel.stateOrProvince.resetValidation();
            _viewModel.zipOrPostalCode.resetValidation();
            _viewModel.inBusinessSince.resetValidation();
            _viewModel.numberOfEmployees.resetValidation();
            _viewModel.industry.resetValidation();
            _viewModel.timeZone.resetValidation();
        };

        const _validateStateOrProvince = (stateOrProvince) => {
            if (_commonValidator.isStringWithValue(stateOrProvince)) {
                return _countryRegions.isValidStateOrProvince(stateOrProvince, _viewModel.country());
            }
            return false;
        };

        const _validateZipOrPostalCodeInvalid = (zipOrPostalCode) => {
            return _validPostalCodeSpecification.isSatisfiedBy(_textConverter.removeAllWhiteSpaces(zipOrPostalCode), _viewModel.country());
        };

        const _validateZipOrPostalCodeExists = (zipOrPostalCode) => {
            return _validPostalCodeSpecification.doesPostalCodeExist(_textConverter.removeAllWhiteSpaces(zipOrPostalCode));
        };

        const _validateMonthYearValid = (monthYearFounded) => {
            if (_commonValidator.isStringWithValue(monthYearFounded)) {
                const MM_YYYY_REGEX = /^(0[1-9]|1[012])\s+?\/?\s+(\d{4})$/;
                if (MM_YYYY_REGEX.test(monthYearFounded)) {
                    const match = MM_YYYY_REGEX.exec(monthYearFounded);
                    if (match) {
                        const month = match[1];
                        const year = match[2];
                        if (!_commonValidator.isNumberBetweenValues(month, 1, 12)) {
                            return false;
                        }
                        const currentYear = new Date().getFullYear();
                        if (!_commonValidator.isNumberBetweenValues(year, 1000, currentYear)) {
                            return false;
                        }
                        const dateFounded = new DateConstructor();
                        const monthZeroIndexed = month - 1;
                        dateFounded.setFromDate(new Date(year, monthZeroIndexed));

                        return !dateFounded.isInTheFuture();
                    }
                }
                return false;
            }
            return true;
        };

        const _validateCompanySize = (companySize) => {
            if (companySize !== "pleaseSelect") {
                return _enumerationValidator.isEnumerationKeyPresent(COMPANY_SIZES, companySize);
            }
            return true;
        };

        const _validateIndustryRequired = (industry) => {
            if (industry !== "pleaseSelect") {
                return _enumerationValidator.isEnumerationValueValid(INDUSTRIES, parseInt(industry));
            }
            return true;
        };

        const _validateWebsiteUrl = (websiteUrl) => {
            if (_commonValidator.isStringWithValue(websiteUrl)) {
                return _validUrlAddressSpecification.isSatisfiedBy(websiteUrl);
            }
            return true;
        };

        const _isEmailAddressUnique = (emailAddress) => {
            let emailAddressMatches = 0;
            _viewModel.billingCommunicationEmailAddresses().forEach((billingCommunicationEmailAddress) => {
                if (billingCommunicationEmailAddress.emailAddress() === emailAddress) {
                    emailAddressMatches++;
                }
            });
            return emailAddressMatches < 2;
        };

        const _stateOrProvinceRequiredI18nKey = ko.pureComputed(() => {
            return _viewModel.country() === _countryEnumerations.ca ?
                'accountProfile:provinceRequired' :
                'accountProfile:stateRequired';
        });

        const _zipOrPostalCodeRequiredI18nKey = ko.pureComputed(() => {
            return _viewModel.country() === _countryEnumerations.ca ?
                'accountProfile:postalCodeRequired' :
                'accountProfile:zipCodeRequired';
        });

        const _zipOrPostalCodeInvalidI18nKey = ko.pureComputed(() => {
            return _viewModel.country() === _countryEnumerations.ca ?
                'accountProfile:postalCodeInvalid' :
                'accountProfile:zipCodeInvalid';
        });
    };
});

